import React, { Suspense } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MainLayout from './layouts/MainLayout';
import routes from './routes';
import './App.css';

function App() {
  return (
    <Router>
      <Suspense fallback={<div>Loading...</div>}>
        <Routes>
          <Route path="/" element={<MainLayout />}>
            {routes.map(({ path, element: Element, index }) => (
              <Route
                key={path || 'index'}
                path={path}
                index={index}
                element={<Element />}
              />
            ))}
          </Route>
        </Routes>
      </Suspense>
    </Router>
  );
}

export default App;
